import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

export const schema: ComponentSchema = {
  type: "lookbook-banner",
  label: "Lookbook Banner",
  description: "Editorial banner — split image/text (V1) or full-width overlay (V2).",
  supportedPages: ["home", "shop", "category"],
  variants: [
    {
      id: "v1",
      label: "V1 — Editorial Split (Image + Text)",
      fields: [
        { key: "image", label: "Image", type: "image" },
        { key: "title", label: "Title", type: "string", default: "The New Collection" },
        { key: "subtitle", label: "Subtitle", type: "text" },
        { key: "ctaText", label: "Button Text", type: "string", default: "View Lookbook" },
        { key: "ctaLink", label: "Button Link", type: "string", default: "/shop" },
        {
          key: "imagePosition",
          label: "Image Position",
          type: "select",
          options: [
            { label: "Left", value: "left" },
            { label: "Right", value: "right" },
          ],
          default: "left",
        },
      ],
    },
    {
      id: "v2",
      label: "V2 — Full-Width Collection Banner",
      fields: [
        { key: "image", label: "Background Image", type: "image" },
        { key: "title", label: "Title", type: "string", default: "The Collection" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Discover the new season" },
        { key: "ctaText", label: "Button Text", type: "string", default: "Shop Now" },
        { key: "ctaLink", label: "Button Link", type: "string", default: "/shop" },
        { key: "overlayOpacity", label: "Overlay Opacity (0–100)", type: "number", default: 40 },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
